(function () {
  if (window.__moboplusLeadTrackingV1) return;
  window.__moboplusLeadTrackingV1 = true;
  document.documentElement.setAttribute('data-moboplus-lead-tracking', 'ready');

  var measurementId = 'G-PCMQT31THT';
  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });
  }

  function track(eventName, eventParams) {
    document.documentElement.setAttribute('data-moboplus-last-lead-event', eventName);
    if (document.documentElement.hasAttribute('data-moboplus-tracking-test')) return;
    var params = eventParams || {};
    params.send_to = measurementId;
    params.page_path = window.location.pathname;
    params.transport_type = 'beacon';
    window.gtag('event', eventName, params);
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href^="tel:"]') : null;
    if (!target) return;
    track('moboplus_phone_click', {
      lead_method: 'phone',
      cta_placement: target.closest('.mpr-mobile-cta') ? 'mobile_sticky_bar' : 'page_content'
    });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'rt-contact-form') return;
    track('moboplus_contact_form_submit', {
      lead_method: 'contact_form',
      form_id: 'rt-contact-form'
    });
  }, true);

  function setupStickyBar() {
    var sticky = document.querySelector('.mpr-mobile-cta');
    var heroActions = document.querySelector('.mpr-hero .mpr-actions');
    if (!sticky || !heroActions) return;
    function updateStickyBar() {
      var rect = heroActions.getBoundingClientRect();
      var shouldShow = window.innerWidth <= 650 && rect.bottom < 0;
      sticky.classList.toggle('is-visible', shouldShow);
    }
    window.addEventListener('scroll', updateStickyBar, { passive: true });
    window.addEventListener('resize', updateStickyBar, { passive: true });
    updateStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickyBar, { once: true });
  } else {
    setupStickyBar();
  }
})();